var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var DefaultSliderContenedor = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: white;\n  padding: ", " 0;\n  border-radius: ", ";\n  border: ", ";\n\n  &.sinBordes {\n    border: unset;\n  }\n"], ["\n  background: white;\n  padding: ", " 0;\n  border-radius: ", ";\n  border: ", ";\n\n  &.sinBordes {\n    border: unset;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.separacion;
}, function (_a) {
    var theme = _a.theme;
    return theme.generalBorderRadius;
}, function (props) { return props.theme.borderDefaultSlider; });
export var ContenedorTitulo = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  p {\n    margin: 0px;\n    margin-bottom: calc(", " / 2);\n  }\n"], ["\n  p {\n    margin: 0px;\n    margin-bottom: calc(", " / 2);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.separacion;
});
var templateObject_1, templateObject_2;
